<template>

	<div></div>

</template>

<script>

export default {
	name: 'Start',
	components: {
		//
	},
	data() {
		return {
			//
		}
	}
}
</script>
